<template>
  <v-layout justify-center data-cy="modal-form-layout">
    <v-dialog
      v-model="show"
      scrollable
      persistent
      :width="width"
      :max-heigth="height"
      @click.stop="close"
      :retain-focus="retainFocus"
      data-cy="modal-form-dialog"
    >
      <v-form
        enctype="multipart/form-data"
        ref="form"
        @submit.prevent="submitDefault"
        :lazy-validation="lazy"
        data-cy="modal-form-"
      >
        <v-card :key="controlKey" :height="height" data-cy="modal-form-card">
          <v-card-title :style="customStyle.title" data-cy="modal-form-card-title">
            <v-layout align-center>
              <v-flex>
                <slot class="headline" name="title"></slot>
              </v-flex>
              <v-flex xs1>
                <v-btn icon @click="close" data-cy="modal-form-card-button-close">
                  <v-icon color="white">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider class="primary"></v-divider>
          <v-card-subtitle v-if="$slots.subtitle" class="pa-0">
            <slot class="headline" name="subtitle"></slot>
          </v-card-subtitle>
          <v-card-text
            style="overflow-x: hidden"
            :class="$attrs['body-class'] || $attrs.bodyClass"
            ref="bodyCard"
            data-cy="modal-form-card-text"
          >
            <slot name="body"></slot>
          </v-card-text>
          <v-divider v-if="!hideFooter" class="primary"></v-divider>
          <v-card-actions :style="customStyle.footer" v-if="!hideFooter" data-cy="modal-form-card-actions">
            <slot name="actions.prepend"></slot>
            <slot name="actions">
              <!--<span class="caption" color="secondary">{{$parent.$options._componentTag}}</span>-->
              <div class="flex-grow-1"></div>
              <v-btn color="white" @click="close" data-cy="modal-form-close">{{
                textClose
              }}</v-btn>
              <v-btn
                v-if="showSubmit && saveContinue"
                :disabled="disableSubmit"
                v-on:click="submitVal = 'save'"
                color="primary"
                type="submit"
                data-cy="modal-form-savecontinue"
                >{{ textSubmitContinue }}</v-btn
              >
              <v-btn
                v-if="showSubmit"
                :disabled="disableSubmit"
                v-on:click="submitVal = 'saveClose'"
                color="primary"
                type="submit"
                data-cy="modal-form-saveclose"
                >{{ textSubmitDefault }}</v-btn
              >
            </slot>
            <slot name="actions.append"></slot>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    value: Boolean,
    size: { default: 'sm' },
    submit: Function,
    model: { type: String, default: 'model' },
    textSubmit: { type: String, default: 'Salvar' },
    textSubmitContinue: { type: String, default: 'Salvar' },
    textClose: { type: String, default: 'Cancelar' },
    hideFooter: { type: Boolean, default: false },
    lazy: { type: Boolean, default: false },
    disableSubmit: { type: Boolean, default: false },
    showSubmit: { type: Boolean, default: true },
    saveContinue: { type: Boolean, default: false },
    retainFocus: { type: Boolean, default: true },
    customStyle: { type: Object, default: () => {} }
  },
  data () {
    return {
      defaultModel: {},
      cleared: true,
      submitVal: null,
      controlKey: 0,
    }
  },
  methods: {
    close: function () {
      this.$parent.show = false
      if (this.$listeners.close) {
        this.$listeners.close()
      } else {
        this.$parent.$emit('close')
      }
    },
    submitDefault: function (e) {
      e.preventDefault()

      if (this.$api.UI.FormValidate(this)) {
        if (this.submit) {
          this.submit(this.reload)
        }
      }
    },
    validate: function (callback) {
      if (this.$api.UI.FormValidate(this)) {
        if (callback) {
          callback()
        }
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    reload: function () {
      const th = this
      th.show = false
      if (th.saveContinue && th.submitVal === 'save') {
        th.$nextTick(function () {
          th.show = true
        })
      } else {
        th.close()
      }
    },
  },
  computed: {
    textSubmitDefault: function () {
      if (this.saveContinue && this.textSubmit === 'Salvar') {
        return 'Salvar e Fechar'
      }
      return this.textSubmit
    },
    show: {
      get () {
        const th = this
        if (!th.value && th.$refs && th.$refs.form && th.showSubmit) {
          if (
            th.model &&
            th.$parent &&
            th.$parent[th.model] &&
            th.defaultModel
          ) {
            th.$nextTick(function () {
              if (!th.cleared) {
                th.$refs.form.reset()
                th.$nextTick(function () {
                  th.$set(th.$parent, th.model, { ...th.defaultModel })
                })
                th.cleared = true
              }
            })
          }
        } else if (this.value) {
          th.$nextTick(function () {
            th.scrollTop(0, 0, th.$refs.bodyCard)
          })
          th.cleared = false
        }

        return this.value
      },
      set (value) {
        this.$parent.$emit('input', value)
      },
    },
    width: {
      get () {
        switch (this.size) {
          case 'sm':
            return '500px'
          case 'md':
            return '700px'
          case 'lg':
            return '1000px'
          case 'xl':
            return '97%'
          default:
            return '500px'
        }
      },
      set () {},
    },
    height: {
      get () {
        switch (this.size) {
          default:
            return '100%'
        }
      },
      set () {},
    },
  },
  watch: {
    // testar em listas auxiliares, motos, stefanini
    // show (value) {
    //   if (value === true) {
    //     this.$nextTick(function () {
    //       this.controlKey++
    //     })
    //   }
    // }
  },
  mounted: function () {
    const th = this
    th.$nextTick(function () {
      if (th.model && th.$parent && th.$parent[th.model]) {
        th.$nextTick(function () {
          var unWatch = th.$watch(
            '$store.getters.activeRequests',
            function (newValue, oldValue) {
              if (newValue === 0) {
                unWatch()
                th.$nextTick(function () {
                  th.defaultModel = th.$api.UTIL.Functions.CopyObject(
                    th.$parent[th.model]
                  )
                })
              }
            },
            { deep: true }
          )
        })
      }
    })
  },
}
</script>
